
// Gallery variable aanmaken om galleries aan te koppelen
var gallery = [];

$(document).ready(function() {
    /**
    * Werking images gallery
    */
    $('.images-container').each(function() {

        $this = $(this);

        var URL = window.URL || window.webkitURL;
        var updateID = $this.attr('id');
        var inputName = $this.data('name');

        var model = $this.data('model');
        var modelId = $this.data('model-id');
        var removeMessage = $this.data('remove-message');
        var cropWidth = parseInt($this.data('width'));
        var cropHeight = parseInt($this.data('height'));

        var cropOptions = {
            autoCropArea: 1,
            aspectRatio: cropHeight === 'auto' ? 'auto' : cropWidth / cropHeight
        };

        // Enable Drag-n-drop for image sorting
        $this.find('.current-images').sortable({
            items: "> [data-id]",
            update: function() {
                // After sorting post to server to update the database
                $.ajax({
                    url: basePath + '/media/' + model + '/' + modelId + '/sort',
                    method: 'post',
                    data: {
                        '_token' : csrf_token,
                        'images' : $(this).sortable('toArray', {attribute:'data-id'}),
                        'type'   : $(this).closest('.images-container').data('name')
                    },
                    dataType: 'JSON',
                    success: function(result) {
                        eModal.alert(result.msg);
                    },
                    error: function(result) {
                        eModal.alert(result.msg);
                    }
                });
            }
        });


        // Actions to perform when clicking on the buttons below each image
        $this.find('.current-images').on('click', '.image-actions button', function() {

            var $thisAction = $(this);
            var action = $thisAction.data('action');
            var $image = $thisAction.closest('.image-container').parent();

            switch(action) {
                case 'edit':
                    eModal.ajax({
                        url: basePath + '/media/' + model + '/' + modelId + '/' + $image.data('id') + '/edit',
                        title:'Afbeelding Info wijzigen',
                        size: eModal.size.lg,
                        buttons: [
                            {
                                text: 'Opslaan', style: 'info', close: true, click: function(a) {
                                    var $editForm = $(this).find('form');

                                    $.ajax({
                                        url: basePath + '/media/' + model + '/' + modelId + '/' + $image.data('id'),
                                        method: 'post',
                                        data: $editForm.serialize(),
                                        dataType: 'JSON',
                                        success: function(result) {
                                            eModal.alert(result.msg);
                                        }
                                    });
                                }
                            },
                            {
                                text: 'Annuleren', style: 'danger', close: true, click: function() {}
                            }
                        ]
                    });

                    break;
                case 'remove':
                    var message = removeMessage;

                    eModal.confirm(message, null)
                        .then(function() {
                            $.ajax({
                                url: basePath + '/media/' + model + '/' + modelId + '/' + $image.data('id'),
                                method: 'post',
                                data: {
                                    '_token' : csrf_token,
                                    '_method' : 'DELETE',
                                    'image_id' : $image.data('id')
                                },
                                dataType: 'JSON',
                                success: function(result) {
                                    $image.fadeOut(500, function() {
                                        eModal.alert(result.msg);
                                    });
                                }
                            });
                        }, function() {
                            return false;
                        });
                    break;
            }
        });

        // Import image
        var inputImage = document.getElementById('input-image-' + updateID);

        if (URL) {
            // When file input contains file to upload...
            inputImage.onchange = function () {

                var croppers = [];
                var files = this.files;
                var file;

                // if we have files ...
                if (files && files.length) {

                    var impromptuStates = [];

                    // loop each file..
                    $.each(files, function(index) {

                        // while we are not at the last file
                        if (files.length > (index + 1)) {

                            // Create the impromptu states for files before the last file
                            impromptuStates['image' + index] = {
                                title: 'Image ' + (index+1),
                                html: function() {

                                    file = files[index];

                                    var $html = $('<div class="crop-image"><img width="100%" height="auto" src="' + URL.createObjectURL(file) + '" alt="Picture"></div>');

                                    var image = $html[0].getElementsByTagName('img')[0];
                                    image.name = file.name;

                                    croppers.push(new Cropper($html[0].getElementsByTagName('img')[0], cropOptions));

                                    URL.revokeObjectURL(file);

                                    return $html;
                                },
                                buttons: { Cancel: false, Next: true },
                                focus: 1,
                                submit:function(e,v,m,f){
                                    if(!v) {
                                        $.prompt.close();
                                    } else {
                                        $.prompt.goToState('image' + (index+1));//go forward
                                    }

                                    return false;
                                }
                            };

                            // if we are at the last file
                        } else {

                            // Create the impromptu states for the last file
                            impromptuStates['image' + index] = {
                                title: 'Image ' + (index+1),
                                html: function() {

                                    file = files[index];

                                    var $html = $('<div class="crop-image"><img width="100%" height="auto" src="' + URL.createObjectURL(file) + '" alt="Picture"></div>');

                                    var image = $html[0].getElementsByTagName('img')[0];
                                    image.name = file.name;

                                    croppers.push(new Cropper($html[0].getElementsByTagName('img')[0], cropOptions));

                                    URL.revokeObjectURL(file);

                                    return $html;
                                },
                                buttons: { Cancel: false, Done: true },
                                focus: 1,
                                submit:function(e,v,m,f){

                                    /**
                                     * v == 0, means cancel all images
                                     * v == 1, crop all images
                                     *
                                     * when impromtu is closed, all files will be uploaded
                                     */

                                    if(v==0) {

                                        $.prompt.close();

                                    } else if (v==1) {


                                        $.each(croppers, function(i) {

                                            var result = croppers[i]['getCroppedCanvas']();
                                            var resultData;

                                            inputIndex = $this.find('.current-images > div').length - 1;

                                            // Uploadbar template
                                            var output =  '';
                                            output += '<div class="upload-file alert alert-info alert-dismissible">';
                                            output += '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
                                                '    <span aria-hidden="true">&times;</span>' +
                                                '  </button>';
                                            output += '     <input class="name" type="hidden" name="upload-file-' + inputName + '[' + inputIndex + '][name]" value="' + croppers[i].element.name + '" />';

                                            var type = 'image/jpeg';
                                            if (croppers[i].element.name.split('.').pop() == 'png') {
                                                type = 'image/png';
                                            }

                                            output += '     <input class="data" type="hidden" name="upload-file-' + inputName + '[' + inputIndex + '][data]" value="' + result.toDataURL(type) + '" />';
                                            output += '     <span class="glyphicon glyphicon-refresh animate-spin"></span>';
                                            output += '     Uploading file: ' + croppers[i].element.name + '<br />';
                                            output += '     <div class="progress">';
                                            output += '         <div class="progress-bar" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;">';
                                            output += '             <span class="sr-only">0% Complete</span>';
                                            output += '         </div>';
                                            output += '     </div>';
                                            output += '</div>';

                                            $('#' + updateID).find('.uploading-files').removeClass('hidden').append(output);

                                            croppers[i].destroy();
                                        });


                                        return true; //we're done
                                    }

                                    return false;
                                }
                            };
                        }
                    });

                    $.prompt(impromptuStates, {
                        close: function(e,v,m,f){

                            /**
                             * When we close impromtu check for files, and upload them
                             */

                            if(v !== undefined){

                                var files = [];

                                $('#' + updateID).find('.uploading-files .upload-file:not(.alert-success)').each(function(index) {

                                    files[index] = [];

                                    files[index].element = $(this);
                                    files[index].progressBar = $(this).find('.progress');

                                    $.ajax({
                                        url: basePath + '/media/' + model + '/' + modelId,
                                        method: 'post',
                                        type: 'json',
                                        data: {
                                            '_token': csrf_token,
                                            'index': index,
                                            'name': files[index].element.find('.name').val(),
                                            'data': files[index].element.find('.data').val(),
                                            'type': inputName
                                        },
                                        //contentType: false,
                                        //processData: false,

                                        headers: {
                                            'X-CSRF-Token': csrf_token
                                        },

                                        // Custom XMLHttpRequest
                                        xhr: function() {
                                            var myXhr = $.ajaxSettings.xhr();
                                            if (myXhr.upload) {
                                                // For handling the progress of the upload
                                                myXhr.upload.addEventListener('progress', function(e) {
                                                    progress = e.loaded;
                                                    if (e.lengthComputable) {
                                                        files[index].progressBar.find('> div').attr({
                                                            'aria-valuenow': e.loaded,
                                                            'aria-valuemax': e.total
                                                        }).width(((e.total/e.loaded) * 100) + '%');
                                                    }
                                                } , false);
                                            }
                                            return myXhr;
                                        },
                                        success: function(result) {
                                            $('#' + updateID).find('.current-images > div:last-child').before(result);

                                            files[index].element.removeClass('alert-info').addClass('alert-success');
                                            files[index].element.find('span.glyphicon').removeClass('glyphicon-refresh animate-spin').addClass('glyphicon-ok');
                                        },
                                        error: function (xhr, ajaxOptions, thrownError) {
                                            result = $.parseJSON( xhr.responseText );
                                            eModal.alert(result.msg);

                                            files[index].element.removeClass('alert-info').addClass('alert-danger');
                                            files[index].element.find('span.glyphicon').removeClass('glyphicon-refresh animate-spin').addClass('glyphicon-remove');
                                        }
                                    });

                                });

                            }
                        },
                        classes: {
                            box: '',
                            fade: '',
                            prompt: '',
                            close: '',
                            title: 'lead',
                            message: '',
                            buttons: '',
                            button: 'btn',
                            defaultButton: 'btn-primary'
                        }
                    });
                }
            };
        }
    });
});

/**
 * Image widget
 *
 * Opent cropper popup om een afbeelding te selecteren
 */
$(document).on('click','.image-widget .btn-warning',function (event) {
    event.preventDefault();

    var $imageWidget = $(this).closest('.image-widget');

    var updateID = $imageWidget.attr('id'); // Btn id clicked
    var size = $imageWidget.data('width') + 'x' + $imageWidget.data('height');
    var cropperUrl = basePath + '/cropper/popup/';

    // trigger the reveal modal with cropper inside
    var triggerUrl = cropperUrl + updateID + '/' + size;
    eModal.iframe(triggerUrl);
});
// Remove the image (empty the fields, image will be removed server side)
$(document).on('click','.image-widget .btn-danger',function (event) {
    event.preventDefault();

    $this = $(this);

    message = $this.attr('title');

    eModal.confirm(message, null)
        .then(function() {
            $this.closest('.image-widget').find('input').attr('value', '');
            $this.closest('.image-widget').find('.image-holder > img').attr('src', 'http://placehold.it/150x150?text=no+image');
        }, function() {
            return false;
        });
});

$(document).on('click','.file-widget .select-file',function (event) {
    event.preventDefault();

    var $fileWidget = $(this).closest('.file-widget');

    // trigger the reveal modal
    var updateID = $fileWidget.attr('id'); // Btn id clicked
    var triggerUrl = basePath + '/elfinder/standalone/' + updateID;

    // trigger the reveal modal with elfinder inside
    eModal.iframe(triggerUrl);
});

/**
 * Takes a data URI and returns the Data URI corresponding to the resized image at the wanted size.
 *
 * @param datas
 * @param imgID
 * @param wantedWidth
 * @param wantedHeight
 */
function resizedataURL(datas, imgID, wantedWidth, wantedHeight) {
    // We create an image to receive the Data URI
    var img = document.getElementById(imgID);
    var dataURI;

    // When the event "onload" is triggered we can resize the image.
    //img.onload = function()
    //{
    // We create a canvas and get its context.
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');

    // We set the dimensions at the wanted size.
    canvas.width = wantedWidth;
    canvas.height = wantedHeight;

    // We resize the image with the canvas method drawImage();
    ctx.drawImage(datas, 0, 0, wantedWidth, wantedHeight);

    dataURI = canvas.toDataURL('image/jpeg');

    /////////////////////////////////////////
    // Use and treat your Data URI here !! //
    /////////////////////////////////////////
    $('#' + imgID + '-data').val(dataURI);
    //};

    // We put the Data URI in the image's src attribute
    //img.src = datas;
}

/**
 * function to update the file selected by elfinder
 *
 * @param files
 * @param requestingField
 */
function processSelectedGalleryFile(files, requestingField) {

    var $requestingFieldElement = $('#' + requestingField);

    var model = $requestingFieldElement.data('model');
    var modelId = $requestingFieldElement.data('model-id');
    var token = $requestingFieldElement.data('token');

    $.ajax({
        url: basePath + '/media/' + model + '/' + modelId,
        method: 'post',
        data: {
            '_token' : token,
            'page_id': modelId,
            'files'  : files
        },
        success: function(result) {
            $('#' + requestingField).find('.current-images > div:last-child').before(result);
        }
    });

}

/**
 * function to update the file selected by elfinder
 *
 * @param file
 * @param requestingField
 */
function processSelectedFile(file, requestingField) {
    console.log(file);
    $('#' + requestingField +  ' input[name="file_name"]').val(file.name);
    $('#' + requestingField +  ' input[name="image"]').val(file.data);
    $('#' + requestingField +  ' input[name="icon"]').val(file.data);
    $('#' + requestingField +  ' input[name="src"]').val(file.data);
    $('#' + requestingField +  ' img').attr('src', file.data);
}